import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=57436c70"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57436c70')) {
      api.createRecord('57436c70', component.options)
    } else {
      api.reload('57436c70', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=57436c70", function () {
      api.rerender('57436c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Setting.vue"
export default component.exports